import GitHubClient from './GitHubClient';
import { decodeBase64 } from '../utils/xmlParser';

/**
 * File loader service - handles loading files from GitHub or local source
 */
class FileLoaderService {
  constructor(githubClient) {
    this.githubClient = githubClient;
  }

  /**
   * Load file from GitHub
   * @param {string} nameAndRepo - Repository path
   * @param {string} filePath - File path in repository
   * @param {string} branch - Branch name
   * @returns {Promise<string>}
   */
  async loadFromGithub(nameAndRepo, filePath, branch) {
    const base64Content = await this.githubClient.getFileContent(
      nameAndRepo,
      filePath,
      branch
    );
    return decodeBase64(base64Content);
  }

  /**
   * Load file from local file reference
   * @param {File} fileRef - File reference
   * @returns {Promise<string>}
   */
  async loadFromLocal(fileRef) {
    return await fileRef.text();
  }
}

export default FileLoaderService;
